import { useEffect } from 'react';

import { authSlice } from './auth.slice';
import { authService } from './authService';
import { useAppDispatch } from 'src/app/store/hooks';
import { useProfileRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';

export function useFetchAndEnsureProfile() {
  const dispatch = useAppDispatch();
  const { data: profile, isLoading, error } = useProfileRetrieveQuery();

  useEffect(() => {
    if (profile) {
      dispatch(authSlice.actions.signIn(profile));
    }
  }, [profile, dispatch]);

  useEffect(() => {
    // A failed profile fetch means the session is missing/expired — send the
    // user to the Hosted UI to (re-)authenticate, not through the full sign-out
    // flow (which clears the session cookie and lands on the marketing site).
    if (error) {
      authService.redirectUnauthedUser();
    }
  }, [error]);

  return {
    isLoading,
  };
}
